export const FLOATING_RESIZE_HANDLES = ['n', 's', 'e', 'w', 'nw', 'ne', 'sw', 'se'];

export const getViewportSize = (win = typeof window !== 'undefined' ? window : null) => {
	if (!win) {
		return { width: 1200, height: 800 };
	}
	return {
		width: win.innerWidth,
		height: win.innerHeight
	};
};

export const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

export const clampFloatingRect = (rect, bounds) => {
	const viewport = bounds.viewport || getViewportSize();
	const gutter = bounds.gutter ?? 12;
	const minWidth = bounds.minWidth ?? 320;
	const minHeight = bounds.minHeight ?? 240;
	const maxWidth = Math.min(bounds.maxWidth ?? viewport.width - gutter * 2, viewport.width - gutter * 2);
	const maxHeight = Math.min(bounds.maxHeight ?? viewport.height - gutter * 2, viewport.height - gutter * 2);

	const width = clamp(rect.width, minWidth, maxWidth);
	const height = clamp(rect.height, minHeight, maxHeight);
	const maxX = Math.max(gutter, viewport.width - width - gutter);
	const maxY = Math.max(gutter, viewport.height - height - gutter);

	return {
		x: clamp(rect.x, gutter, maxX),
		y: clamp(rect.y, gutter, maxY),
		width,
		height
	};
};

export const applyDragDelta = (startRect, deltaX, deltaY, bounds) => {
	return clampFloatingRect({
		...startRect,
		x: startRect.x + deltaX,
		y: startRect.y + deltaY
	}, bounds);
};

export const applyResizeDelta = (startRect, handle, deltaX, deltaY, bounds) => {
	let { x, y, width, height } = startRect;
	const startRight = startRect.x + startRect.width;
	const startBottom = startRect.y + startRect.height;

	if (handle.includes('e')) {
		width = startRect.width + deltaX;
	}
	if (handle.includes('w')) {
		width = startRect.width - deltaX;
	}
	if (handle.includes('s')) {
		height = startRect.height + deltaY;
	}
	if (handle.includes('n')) {
		height = startRect.height - deltaY;
	}

	const viewport = bounds.viewport || getViewportSize();
	const gutter = bounds.gutter ?? 12;
	const resizeBounds = { ...bounds, viewport };

	if (handle.includes('w')) {
		resizeBounds.maxWidth = Math.min(
			bounds.maxWidth ?? viewport.width - gutter * 2,
			startRight - gutter
		);
	}
	if (handle.includes('n')) {
		resizeBounds.maxHeight = Math.min(
			bounds.maxHeight ?? viewport.height - gutter * 2,
			startBottom - gutter
		);
	}

	const resized = clampFloatingRect({ x, y, width, height }, resizeBounds);

	// West/north handles anchor the opposite edge. Restore that edge after
	// clamping so hitting a min/max size does not move the panel unexpectedly.
	if (handle.includes('w')) {
		resized.x = startRight - resized.width;
	}
	if (handle.includes('n')) {
		resized.y = startBottom - resized.height;
	}

	return resized;
};

export const clampDockWidth = (width, bounds) => {
	const viewport = bounds.viewport || getViewportSize();
	const gutter = bounds.gutter ?? 12;
	const minWidth = bounds.minWidth ?? 320;
	const maxWidth = bounds.maxWidth ?? Math.floor(viewport.width * 0.7);
	return clamp(width, minWidth, Math.min(maxWidth, viewport.width - gutter * 2));
};
